import { ENDPOINT } from '~/constants/endpoints';

import { type UUID } from '~/types/common';

import { type KyRequestOptions } from '@vestigas/data';

import { vestigasApi } from '~/services/kyClient';

import { zodDeleteCallOffEndpointSchema } from './validations';

/**
 * Deletes a call-off by its ID.
 * Soft deletes the call-off by setting its status to DELETED.
 *
 * @param callOffId - The ID of the call-off to delete.
 * @param options - Optional request options (e.g., abort signal).
 * @returns A promise that resolves when the call-off is deleted.
 *
 * @see https://app.dev.vestigas.com/redoc#tag/Call-Offs/operation/delete_calloff_calloffs__calloff_id__delete
 */
export const deleteCallOff = async (
  callOffId: UUID,
  options?: KyRequestOptions,
) => {
  const response = await vestigasApi
    .delete(ENDPOINT.CALL_OFF.DELETE(callOffId), {
      validate: {
        pathSegments: zodDeleteCallOffEndpointSchema,
      },
      ...options,
    })
    .text();

  return response;
};
